// A8.netでサイトID 006（https://sumaho-minaoshi.com/）向けに発行した広告素材。
// 広告コードは改変せず、表示箇所の外側でPR表記と説明を付ける。
export const approvedAds = {
  ahamo: '<a href="https://px.a8.net/svt/ejp?a8mat=4BCBRC+DXB3ZU+4TIO+5YJRM" rel="nofollow">ahamo</a> <img border="0" width="1" height="1" src="https://www18.a8.net/0.gif?a8mat=4BCBRC+DXB3ZU+4TIO+5YJRM" alt="">',
  // 楽天アフィリエイトの楽天モバイルショップリンク（テキストのみ）。発行コードをそのまま掲載する。
  rakuten: '<a href="https://hb.afl.rakuten.co.jp/hsc/57e07128.1f812976.57e07129.192400c1/?link_type=text&rafst=rmn&ut=eyJwYWdlIjoic2hvcCIsInR5cGUiOiJ0ZXh0IiwiY29sIjoxLCJjYXQiOjEsImJhbiI6Im5hbWUiLCJhbXAiOmZhbHNlfQ%3D%3D" target="_blank" rel="nofollow sponsored noopener" style="word-wrap:break-word;">楽天モバイル</a>',
} as const;
